import { render, staticRenderFns } from "./holidays-category.vue?vue&type=template&id=b6e2423e&scoped=true"
import script from "./holidays-category.vue?vue&type=script&lang=js"
export * from "./holidays-category.vue?vue&type=script&lang=js"
import style0 from "./holidays-category.vue?vue&type=style&index=0&id=b6e2423e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e2423e",
  null
  
)

export default component.exports